<template>
	<div class="intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5">
		<div v-for="(data, index) in filteredFiles" :key="index" class="intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-3">
			<file :data="data" :index="index"></file>
		</div>
	</div>
</template>

<script>
	import File from "@/components/File";
	
	export default {
		props: ["searchTerm","limit","order"],
		components:{
			File
		},
		data() {
			return {
				data:[]
			};
		},
		computed:{
			filteredFiles(){
				var data = this.data;
				if (this.searchTerm) data = this.data.filter(rec => rec.title && rec.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1);
				if (this.limit) data = data.slice(0,this.limit);
				return data;
			}
		},
		mounted(){
        	window.bus.$on('dataReloaded', () => this.loadData());
			this.loadData();
		},
		watch: {},
		methods: {
			loadData(){
				CmsApi.hook("/hooks/getDescarga/",{searchterm:this.searchTerm,limit:this.limt,order:this.order,token:this.$cookie.get("token")},(data) => {
					if (data.success && data.data) this.data = data.data;
				});
			}
		}
	};

</script>
